import * as styles from 'styles/pages/Styleguide.css'
import { Caption } from 'components/atoms/Text'
import Paginator from 'components/molecules/tables/Paginator'

const SGTables = () => (
  <section className={ styles.sgSection }>
    <Paginator recordsCount={ 134 } pageSize={ 25 } page={ 2 } onPageChange={ () => null } />
    <Caption text='table pagination' />
  </section>
)

export default SGTables
